export default __webpack_public_path__ + "static/media/cross.151b1fb2.svg";